import OrderNowModal from './OrderNowModal';

export default OrderNowModal;
